import {
  PRD_BSC_DEPOSIT_CONTRACT_ABI,
  PRD_BSC_USDT_BEP20_APPROVE_ABI,
  PRD_BSC_WITHDRAW_ABI,
} from './bsc-abi.prd';
import {
  STG_BSC_DEPOSIT_CONTRACT_ABI,
  STG_BSC_LOAN_DEPOSIT_CONTRACT_ABI,
  STG_BSC_USDT_BEP20_APPROVE_ABI,
  STG_BSC_WITHDRAW_ABI,
} from './bsc-abi.stg';

export * from './bsc-abi.prd';
export * from './bsc-abi.stg';

const isStg = process.env.NEXT_PUBLIC_ENV === 'stg';

const bscDepositContractAbi = isStg
  ? STG_BSC_DEPOSIT_CONTRACT_ABI
  : PRD_BSC_DEPOSIT_CONTRACT_ABI;

const bscLoanDepositContractAbi = isStg
  ? STG_BSC_LOAN_DEPOSIT_CONTRACT_ABI
  : PRD_BSC_DEPOSIT_CONTRACT_ABI;

const usdtBEP20ApproveAbi = isStg
  ? STG_BSC_USDT_BEP20_APPROVE_ABI
  : PRD_BSC_USDT_BEP20_APPROVE_ABI;

const bscClaimAbi = isStg ? STG_BSC_WITHDRAW_ABI : PRD_BSC_WITHDRAW_ABI;

export {
  bscClaimAbi,
  bscDepositContractAbi,
  bscLoanDepositContractAbi,
  usdtBEP20ApproveAbi,
};
